import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';

import { applyMiddleware, createStore, } from 'redux';
import { Provider } from 'react-redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import reducer from './reducers';

// App
import App from './App';
// Home
import Home from './components/home/Home';

// OSH Context
import OSHAuthorities from './components/osh-context/OSHAuthorities';
import EconomicSectorProfile from './components/osh-context/EconomicSectorProfile';
import WorkforceProfile from './components/osh-context/WorkforceProfile';
import Forecasts from './components/osh-context/Forecasts';

// OSH Steering
import Regulation from './components/osh-steering/Regulation';
import NationalStrategies from './components/osh-steering/NationalStrategies';
import CountryProfile from './components/osh-steering/CountryProfile';
import EUChallengesResponse from './components/osh-steering/EUChallengesResponse';
import SocialDialogue from './components/osh-steering/SocialDialogue';
import DevelopmentEUCountries from './components/osh-steering/DevelopmentEUCountries';
import CountryOverview from './components/osh-steering/CountryOverview';
import SocialDialogueIndicator from './components/osh-steering/SocialDialogueIndicator';
import WorkerInvolvement from './components/osh-steering/WorkerInvolvement';

// Working conditions and prevention
import WorkingConditions from './components/osh-outcomes-working-conditions/WorkingConditions';
import OverallOpinion from './components/osh-outcomes-working-conditions/OverallOpinion';
import PsychosocialRisk from './components/osh-outcomes-working-conditions/PsychosocialRisk';
import PhysicalRisk from './components/osh-outcomes-working-conditions/PhysicalRisk';
import SafetyRisks from './components/osh-outcomes-working-conditions/SafetyRisks';
import DigitalisationRisks from './components/osh-outcomes-working-conditions/DigitalisationRisks';
import PreventionCompanies from './components/osh-outcomes-working-conditions/PreventionCompanies';
import OSHCulture from './components/osh-outcomes-working-conditions/OSHCulture';

// Accidents, diseases and well-being
import WorkAccidents from './components/osh-outcomes-working-conditions/WorkAccidents';
import DataOnWorkersHealth from './components/osh-outcomes-working-conditions/DataOnWorkersHealth';
import HealthPerception from './components/osh-outcomes-working-conditions/HealthPerception';
import HealthComparedPeers from './components/osh-outcomes-working-conditions/HealthComparedPeers';
import ReportedHealthProblems from './components/osh-outcomes-working-conditions/ReportedHealthProblems';
import WorkRelatedDiseases from './components/osh-outcomes-working-conditions/WorkRelatedDiseases';

// OSH Infrastructure
import EnforcementCapacity from './components/osh-infrastructure/EnforcementCapacity';
import EnforcementAuthorities from './components/osh-infrastructure/EnforcementAuthorities';
import OSHStatistics from './components/osh-infrastructure/OSHStatistics';
import Organisations from './components/osh-infrastructure/Organisations';
import Programmes from './components/osh-infrastructure/Programmes';

// Resources
import Publications from './components/resources/Publications';
import CountryReportHome from './components/resources/CountryReportHome';

// About Tool
import GeneralInformation from './components/about-tool/GeneralInformation';
import Methodology from './components/about-tool/Methodology';
import CountryReport from './components/about-tool/CountryReport';

// Footer
import Accesibility from './components/footer-pages/Accesibility';
import Cookies from './components/footer-pages/Cookies';
import LegalNotice from './components/footer-pages/LegalNotice';
import PageNotFound from './components/footer-pages/PageNotFound';
import PrivacyPolicy from './components/footer-pages/PrivacyPolicy';
import Sitemap from './components/footer-pages/Sitemap';
import ScrollToTop from './components/common/hook/ScrollToTop';

// Report Generation for the Edition Tool
import OSHAuthoritiesReport from './components/about-tool/OSHAuthoritiesReport';
import NationalStrategiesReport from './components/about-tool/NationalStrategiesReport';

//Matomo and Cookies
import { CookiesProvider } from 'react-cookie';
import { MatomoProvider, createInstance } from '@datapunt/matomo-tracker-react';

const middlewares = composeWithDevTools(
	applyMiddleware(),
)

if (window.location.href.indexOf('#!') > -1)
{
	// Check if the #! is between / symbols
	if (window.location.href.indexOf('/#!/') > -1)
	{
		window.location.href = window.location.href.replace('#!/', '');
	}
	else
	{
		window.location.href = window.location.href.replace('#!', '');
	}	
}

const store = createStore(reducer, middlewares);
let literals = require('./model/Literals.json');
fetch(`${process.env.PUBLIC_URL}/model/Literals.json`)
.then(function(response){
	return response.json();
})
.then(function(myJson) {
	literals = myJson;

	const PIWIK = process.env.PIWIK != undefined ? process.env.PIWIK : "local" ;
	const DVT = process.env.DVT != undefined ? process.env.DVT : "local" ;
	let configuration = require('../src/components/common/cookies/cookiesConfig.json');
	let url = configuration.paths.piwik[PIWIK].protocol + ":" + configuration.paths.piwik[PIWIK].domain + ":" + configuration.paths.piwik[PIWIK].port + configuration.paths.piwik[PIWIK].path;
	let basePath = configuration.paths.enviroment[DVT].domain + ":" + configuration.paths.enviroment[DVT].port + "/";
	const instance = createInstance({
		urlBase: basePath, //https://LINK.TO.DOMAIN',
		siteId: configuration.paths.piwik[PIWIK].SiteId, //3
		trackerUrl: url+'piwik.php', //'https://LINK.TO.DOMAIN/tracking.php', // optional, default value: `${urlBase}matomo.php`
		srcUrl: url+'piwik.js', //'https://LINK.TO.DOMAIN/tracking.js', // optional, default value: `${urlBase}matomo.js`
		disabled: false, // optional, false by default. Makes all tracking calls no-ops if set to true.
		linkTracking: true, // optional, default value: true,
		configurations: { // optional, default value: {}
			// any valid matomo configuration, all below are optional
			setCampaignNameKey: 'euosha_campaign',
			setCampaignKeywordKey: 'euosha_kwd',
		addTracker: ['https://piwik.osha.europa.eu:443/piwik/piwik.php', configuration.paths.piwik[PIWIK].SiteId]
		}
	});

	ReactDOM.render(
		<MatomoProvider value={instance}>
		<CookiesProvider>
		<Provider store={store}>
			<BrowserRouter basename="osh-barometer" >
			<ScrollToTop>
				<Switch>
					<Route exact path="/" render={() => <App literals={literals}><Home literals={literals}/></App>} />
					
					{/* OSH CONTEXT */}
					<Route 
						path="/osh-context/osh-authorities/:country?" 
						render={routeParams => <App literals={literals}><OSHAuthorities literals={literals} country={routeParams.match.params.country} /></App>} 
					/>
					<Route 
						path="/osh-context/economic-sector-profile/:country1?/:country2?/:country3?" 
						render={routeParams => <App literals={literals}><EconomicSectorProfile country1={routeParams.match.params.country1} country2={routeParams.match.params.country2} country3={routeParams.match.params.country3} literals={literals}/></App>} 
					/>
					<Route
						path="/osh-context/workforce-profile/:indicator/:subIndicator" 
						render={routeParams => <App literals={literals}><WorkforceProfile literals={literals} indicator={routeParams.match.params.indicator} subIndicator={routeParams.match.params.subIndicator}/></App>} 
					/>
					<Route 
						path="/osh-context/forecasts/:indicator/:subIndicator/:country1?/:country2?/:country3?" 
						render={routeParams => <App literals={literals} ><Forecasts literals={literals} indicator={routeParams.match.params.indicator} 
						subIndicator={routeParams.match.params.subIndicator} country1={routeParams.match.params.country1} country2={routeParams.match.params.country2} country3={routeParams.match.params.country3} /></App>} 
					/>

          			{/* STEERING OF OSH */}
					<Route
						path="/osh-steering/regulation/:indicator?" 
						render={routeParams => <App literals={literals}><Regulation literals={literals} indicator={routeParams.match.params.indicator} /></App>} 
					/>
					<Route exact 
					  	path="/osh-steering/national-strategies" 
					  	render={() => <App literals={literals}><NationalStrategies literals={literals}/></App>}
				  	/>	
					<Route exact 
						path="/osh-steering/country-profile/:indicator/:country1?/:country2?/:country3?" 
						render={routeParams => <App literals={literals}><CountryProfile indicator={routeParams.match.params.indicator} country1={routeParams.match.params.country1} country2={routeParams.match.params.country2} country3={routeParams.match.params.country3} literals={literals}/></App>} 
					/>
          			<Route exact 
						path="/osh-steering/eu-challenges-response/:country" 
						render={(props) => <App literals={literals}><EUChallengesResponse {...props} literals={literals}  /></App>}
					/>								
					<Route exact 
						path="/osh-steering/social-dialogue" 
						render={() => <App literals={literals}><SocialDialogue literals={literals}/></App>}
					/>
					<Route exact 
						path="/osh-steering/social-dialogue/development-eu-countries" 
						render={() => <App literals={literals}><DevelopmentEUCountries literals={literals}/></App>}
					/>
					<Route exact 
						path="/osh-steering/social-dialogue/development-eu-countries/country-overview" 
						render={() => <App literals={literals}><CountryOverview literals={literals}/></App>} 
					/>
					<Route exact 
						path="/osh-steering/social-dialogue/social-dialogue-indicator" 
						render={() => <App literals={literals}><SocialDialogueIndicator literals={literals}/></App>}
					/>					
					<Route 
						path="/osh-steering/social-dialogue/worker-involvement/:split?/:country1?/:country2?/:country3?" 
						render={routeParams => <App literals={literals}><WorkerInvolvement literals={literals} split={routeParams.match.params.split} country1={routeParams.match.params.country1} country2={routeParams.match.params.country2} country3={routeParams.match.params.country3} indicator={routeParams.match.params.indicator}/></App>} 
					/>
					
					{/* WORKING CONDITIONS AND PREVENTION */}
					<Route exact 
						path="/working-conditions-preventions/working-conditions" 
						render={routeParams => <App literals={literals}><WorkingConditions literals={literals}  country1={routeParams.match.params.country1} country2={routeParams.match.params.country2} country3={routeParams.match.params.country3} /></App>} 
					/>
					<Route 
						path="/working-conditions-preventions/overall-opinion/:indicator/:country1?/:country2?/:country3?" 
						render={routeParams => <App literals={literals}><OverallOpinion country1={routeParams.match.params.country1} country2={routeParams.match.params.country2} country3={routeParams.match.params.country3} literals={literals} indicator={routeParams.match.params.indicator}  /></App>} 
					/>
					<Route 
						path="/working-conditions-preventions/mental-risk/risk-factors/:indicator?/:dataset?" 
						render={routeParams => <App literals={literals}><PsychosocialRisk literals={literals} tab="risk-factors" indicator={routeParams.match.params.indicator} dataset={routeParams.match.params.dataset}/></App>} 
					/>
					<Route 
						path="/working-conditions-preventions/mental-risk/initiatives-support/:indicator?/:dataset?" 
						render={routeParams => <App literals={literals}><PsychosocialRisk literals={literals} tab="initiatives-support" indicator={routeParams.match.params.indicator}/></App>} 
					/>					
					<Route 
						path="/working-conditions-preventions/physical-risk/vibrations-loud-noise-and-temperature/:country1?/:country2?/:country3?" 
						render={routeParams => <App literals={literals} ><PhysicalRisk literals={literals} tab='vibrations-loud-noise-and-temperature' country1={routeParams.match.params.country1} country2={routeParams.match.params.country2} country3={routeParams.match.params.country3}/></App>} 
					/>
					<Route 
						path="/working-conditions-preventions/physical-risk/exposure-to-dangerous-substances/:indicator" 
						render={routeParams => <App literals={literals} ><PhysicalRisk literals={literals} tab='exposure-to-dangerous-substances' indicator={routeParams.match.params.indicator} /></App>} 
					/>
					<Route 
						path="/working-conditions-preventions/physical-risk/ergonomic-risks/:dataset/:country1?/:country2?/:country3?" 
						render={routeParams => <App literals={literals} ><PhysicalRisk literals={literals} tab='ergonomic-risks' dataset={routeParams.match.params.dataset} country1={routeParams.match.params.country1} country2={routeParams.match.params.country2} country3={routeParams.match.params.country3}/></App>} 
					/>
					<Route
						path="/working-conditions-preventions/safety-risks/fatal-accidents/:indicator?" 
						render={routeParams => <App literals={literals}><SafetyRisks literals={literals} tab='fatal-accidents' indicator={routeParams.match.params.indicator} /></App>} 
					/>
					<Route
						path="/working-conditions-preventions/safety-risks/non-fatal-accidents/:indicator?" 
						render={routeParams => <App literals={literals}><SafetyRisks literals={literals} tab='non-fatal-accidents' indicator={routeParams.match.params.indicator} /></App>} 
					/>
					<Route
						path="/working-conditions-preventions/digitalisation-risks/effects-digitalisation/:indicator?" 
						render={routeParams => <App literals={literals}><DigitalisationRisks literals={literals} tab='effects-digitalisation' indicator={routeParams.match.params.indicator} /></App>} 
					/>
					<Route
						path="/working-conditions-preventions/digitalisation-risks/use-digitalisation/:indicator?" 
						render={routeParams => <App literals={literals}><DigitalisationRisks literals={literals} tab='use-digitalisation' indicator={routeParams.match.params.indicator} /></App>} 
					/>
					<Route 
						path="/working-conditions-preventions/prevention-companies/:indicator/:split?/:country1?/:country2?/:country3?" 
						render={routeParams => <App literals={literals}><PreventionCompanies literals={literals} indicator={routeParams.match.params.indicator} 
						split={routeParams.match.params.split} country1={routeParams.match.params.country1 } country2={routeParams.match.params.country2} country3={routeParams.match.params.country3} /></App>} 
					/>
					<Route
						path="/working-conditions-preventions/osh-culture/:indicator" 
						render={routeParams => <App literals={literals}><OSHCulture literals={literals} indicator={routeParams.match.params.indicator} /></App>} 
					/>

					{/* ACCIDENTS DISEASES AND WELL-BEING */}
					<Route 
						path="/accidents-diseases-well-being/work-accidents/:firstLevel/:indicator?/:country1?/:country2?/:country3?" 
						render={routeParams => <App literals={literals}><WorkAccidents literals={literals} firstLevel={routeParams.match.params.firstLevel} indicator={routeParams.match.params.indicator}  country1={routeParams.match.params.country1} country2={routeParams.match.params.country2} country3={routeParams.match.params.country3} /></App>} 
					/>
					<Route 
						path="/accidents-diseases-well-being/work-accidents/serious-non-fatal-work-accidents" 
						render={routeParams => <App literals={literals}><WorkAccidents literals={literals} firstLevel='serious-non-fatal-work-accidents' indicator={routeParams.match.params.indicator}  country1={routeParams.match.params.country1} country2={routeParams.match.params.country2} country3={routeParams.match.params.country3} /></App>} 
					/>
					<Route 
						path="/accidents-diseases-well-being/work-related-diseases/:dataset/:indicator/:illness?" 
						render={routeParams => <App literals={literals} ><WorkRelatedDiseases literals={literals} dataset={routeParams.match.params.dataset} 
						indicator={routeParams.match.params.indicator} illness={routeParams.match.params.illness} /></App>} 
					/>
					<Route exact 
						path="/accidents-diseases-well-being/data-on-workers-health" 
						render={() => <App literals={literals}><DataOnWorkersHealth literals={literals}/></App>}
					/>
					<Route exact 
						path="/accidents-diseases-well-being/data-on-workers-health/health-perception" 
						render={() => <App literals={literals}><HealthPerception literals={literals}/></App>}
					/>
					<Route exact 
						path="/accidents-diseases-well-being/data-on-workers-health/health-compared-to-peers" 
						render={() => <App literals={literals}><HealthComparedPeers literals={literals}/></App>}
					/>
					<Route exact 
						path="/accidents-diseases-well-being/data-on-workers-health/reported-health-problems/:category" 
						render={routeParams => <App literals={literals}><ReportedHealthProblems literals={literals}
						category={routeParams.match.params.category}
						/></App>}
					/>

					{/* OSH INFRASTRUCTURE */}
					<Route
						path="/osh-infrastructure/enforcement-authorities/:indicator/:country1?/:country2?/:country3?" 
						render={routeParams => <App literals={literals}><EnforcementAuthorities literals={literals} indicator={routeParams.match.params.indicator} country1={routeParams.match.params.country1} country2={routeParams.match.params.country2} country3={routeParams.match.params.country3} /></App>} 
					/>
					<Route
						path="/osh-infrastructure/enforcement-capacity/:dataset/:indicator?" 
						render={routeParams => <App literals={literals}><EnforcementCapacity literals={literals} dataset={routeParams.match.params.dataset} indicator={routeParams.match.params.indicator} country1={routeParams.match.params.country1} country2={routeParams.match.params.country2} country3={routeParams.match.params.country3} /></App>} 
					/>
					<Route 
						path="/osh-infrastructure/osh-statistics/:country?" 
						render={routeParams => <App literals={literals}><OSHStatistics literals={literals} country={routeParams.match.params.country} /></App>} 
					/>
					<Route 
						path="/osh-infrastructure/international-organisations" 
						render={() => <App literals={literals}><Organisations literals={literals} /></App>} 
					/>
					<Route 
						path="/osh-infrastructure/international-programmes/:organisation?" 
						render={routeParams => <App literals={literals}><Programmes literals={literals} organisation={routeParams.match.params.organisation} /></App>} 
					/>
					
					{/* RESOURCES */}
					<Route 
						path="/resources/publications" 
						render={routeParams => <App literals={literals}><Publications literals={literals} /></App>} 
					/>
					<Route 
						path="/resources/country-report" 
						render={routeParams => <App literals={literals}><CountryReportHome literals={literals}/></App>} 
					/>
					
					{/* ABOUT THE SYSTEM */}
					<Route exact 
						path="/about-the-system" 
						render={() => <App literals={literals}><GeneralInformation literals={literals}/></App>}
					/>
					<Route exact 
						path="/about-the-system/methodology" 
						render={() => <App literals={literals}><Methodology literals={literals}/></App>} 
					/>
					<Route exact 
						path="/full-country-report" 
						render={() => <CountryReport literals={literals} />} 
					/>

					{/* FOOTER PAGES */}
					<Route exact path="/accessibility" render={() => <App literals={literals}><Accesibility literals={literals}/></App>} />
					<Route exact path="/cookies" render={() => <App literals={literals}><Cookies literals={literals}/></App>} />
					<Route exact path="/legal-notice" render={() => <App literals={literals}><LegalNotice literals={literals}/></App>} />
					<Route exact path="/page-not-found" render={() => <App literals={literals}><PageNotFound literals={literals}/></App>} />
					<Route exact path="/privacy-notice" render={() => <App literals={literals}><PrivacyPolicy literals={literals} /></App>} />
					<Route exact path="/sitemap" render={() => <App literals={literals}><Sitemap literals={literals}/></App>} />

					<Route 
						path="/osh-authorities-report/:country" 
						render={routeParams => <OSHAuthoritiesReport literals={literals} country={routeParams.match.params.country} />} 
					/>
					<Route 
						path="/national-strategies-report/:country" 
						render={routeParams => <NationalStrategiesReport literals={literals} country={routeParams.match.params.country} />} 
					/>

					<Redirect to="/page-not-found" />
				</Switch>
				</ScrollToTop>		
			</BrowserRouter>
		</Provider>
		</CookiesProvider>
		</MatomoProvider>, 
		document.getElementById('root')
	);
});

